<template>
  <div
    v-if="agentName"
    class="expi-agency"
  >
    <span
      class="fa fa-user-circle setting"
      @click="handleSettingsClick"
    />
    <span>{{ agentName }}</span>
    <span
      v-if="expiCode"
      class="agency-number"
    >
      (AgenturNr:
      <span class="expi-strong">&nbsp;{{ agencyId }}</span>| EXPIcode:
      <span class="expi-strong">&nbsp;{{ expiCode }}</span>)
    </span>
    <span
      v-else
      class="agency-number"
    >
      (AgenturNr:
      <span class="expi-strong">&nbsp;{{ agencyId }}</span>)
    </span>
    <div
      v-if="settingsOpen"
      class="settings-mask"
      @click.stop="handleSettingsClick"
    />
    <div
      v-if="settingsOpen"
      class="settings-panel"
      @click.stop
      @dblclick.stop
    >
      <template v-if="agencyId==='AIDA AKC'">
        <div class="contact-preview">
          {{ agentName }}
          <br>
          {{ agentEmail }}
          <br>
        </div>
      </template>
      <template v-else>
        <template v-if="agencyId==='AIDASEE'">
          <div class="contact-preview">
            {{ agentName }}
            <br>
          </div>
        </template>
        <template v-else>
          <div class="contact-preview">
            {{ agencyName }}
            <br>
            {{ agentName }}
            <br>
            {{ agencyEmail }}
            <br>
            {{ agencyPhone }}
            <br>
          </div>
        </template>
      </template>
      <hr class="devider m-0 w-100 opacity-100">
      <div class="w-100 d-flex mt-2 justify-content-between">
        <ToggleButton 
          :checked="pdfWithAgencyInformation"
          :translate-with-default="getText"
          label-id="Kontaktdaten im PDF anzeigen"
          :small="true"
          button-color="expi-blue"
          @click="togglePdfSetting(pdfWithAgencyInformation)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useUserStore } from '@/store/user'
import ToggleButton from '@gecko-akh/aos-toggle-button'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

export default defineComponent({
  components: { ToggleButton },
  data: () => {
    return {
      settingsOpen: false,
    }
  },
  computed: {
    ...mapState(useUserStore, {
      agentId: store => store.agentId,
      expiCode: store => store.expiCode,
      agencyId: store => store.agencyId,
      agentName: store => store.agentName,
      agentEmail: store => store.agentEmail,
      agencyName: store => store.agencyName,
      agencyEmail: store => store.agencyEmail,
      agencyPhone: store => store.agencyPhone,
      pdfWithAgencyInformation: store => store.pdfWithAgencyInformation,
    }),
  },
  methods: {
    ...mapActions(useUserStore, {
      setPdfWithAgencyInformation: 'setPdfWithAgencyInformation'
    }),

    handleSettingsClick() {
      this.settingsOpen = !this.settingsOpen
    },
    async togglePdfSetting(fieldValue: boolean) {
      await this.setPdfWithAgencyInformation(!fieldValue)
    },

    // TODO: replace with correct method when AEM is used
    getText:(labelId: string) => {
      return labelId
    }
  },
})
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.expi-agency span {
  display: inline-block;
  vertical-align: middle;
}
.expi-agency {
  font-size: 12px;
}
.agency-number {
  margin-right: 10px;
}
.expi-strong {
  font-weight: bold;
  margin-bottom: 3px;
}
.setting {
  font-size: 20px;
  color: $color-expinet-gray;
  margin-left: 10px;
  margin-right: 5px;

  &:hover {
    color: $color-expinet-dark-gray;
    cursor: pointer;
  }
}
.settings-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 199;
}
.settings-panel {
  width: 300px;
  background-color: $color-aida-white;
  position: absolute;
  right: 0px;
  margin-right: 6px;
  margin-top: 11px;
  z-index: 200;
  border: 1px solid $color-expinet-gray;
  padding: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 30px 8px rgba(0, 0, 0, 0.22);
}
.contact-preview {
  width: 100%;
  margin-bottom: 10px;
  line-height: 1.3;
}
.devider {
  color: $color-expinet-gray;
  border-color: $color-expinet-gray;
}
</style>